import { useState, useEffect } from "react";
import { Button, Box, TextField, Typography } from "@mui/material";
import { UseProductGroup } from "./UseProductGroup";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

function AddChildProductGroup(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [group, setGroup] = useState();
  const { validate, addGroup } = UseProductGroup();
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    faName: undefined,
    enName: undefined,
    metaDescription: undefined,
    description: "",
    parentGroup: { ID: location.state.id },
  });

  const [errorState, setErrorState] = useState({
    faName: false,
    enName: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/productgroups" },
          { name: "زیر گروه جدید", url: "/productgroups/addChildproductgroup" },
        ],
      }}
    >
      {!group ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              sx={{ mt: 1, width: "100%" }}
              value={state.faName ? state.faName : ""}
              error={errorState.faName}
              label="نام فارسی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, faName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              id="outlined-basic"
              value={state.enName ? state.enName : ""}
              error={errorState.enName}
              sx={{
                width: "100%",
                input: { direction: "rtl" },
              }}
              label="نام لاتین"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, enName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn="span 12">
            <Typography sx={{ mb: 1 }} variant="subtitle1" color="secondary">
              توضیحات
            </Typography>
            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              data={state.description}
              style={{ p: "100px", width: "100%" }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setState({ ...state, description: data });
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "350px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>
          <Box gridColumn="span 12">
            <Typography sx={{ mb: 1 }} variant="subtitle1" color="secondary">
              توضیحات متا :
            </Typography>
            <TextField
              fullWidth
              value={state.metaDescription ? state.metaDescription : ""}
              multiline
              maxRows={5}
              onChange={(evt) => {
                if (evt.target.value.length < 151) {
                  setState({ ...state, metaDescription: evt.target.value });
                  return;
                } else {
                  setState({
                    ...state,
                    metaDescription: state.metaDescription,
                  });
                  enqueueSnackbar("بیشتر از مقدار مجاز (150 کاراکتر)", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
              }}
              size="small"
              variant="outlined"
            />
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  addGroup(state, () => {
                    navigate("/productgroups", {
                      state: location.state,
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/productgroups", {
                  state: location.state,
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default AddChildProductGroup;
